<section class="download-app">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 left-column">
                <h3 class="text-light">You can now download World of Sweets Mobile App <br> as well to order fresh and
                    manage all your previous orders</h3>
                <p class="text-light">Enter your mobile number to receive a link to download the app.</p>
                <form class="form-with-button" [formGroup]="appLinksForm" (ngSubmit)="sendSms()" autocomplete="off">
                    <div class="form-group">
                        <input type="text" maxLength="20" placeholder="E.g. 07537177369" class="form-control"
                            formControlName="mobileNumber">
                        <div *ngIf="submitted && appLinksForm.controls.mobileNumber.errors" class="error">
                            <div *ngIf="appLinksForm.controls.mobileNumber.errors.required"><img
                                    src="/assets/images/error.svg" /> Mobile Number is required</div>
                            <div *ngIf="appLinksForm.controls.mobileNumber.errors?.pattern"><img
                                    src="/assets/images/error.svg" /> Mobile Number should be valid</div>
                        </div>
                        <button type="submit" class="btn primary-btn">Get Download Link</button>
                    </div>
                </form>
                <ul>
                    <li>
                        <div>
                            <a href="{{user.app_path.ios_path}}" (click)="iosAppEvent()"><img
                                    src="../../assets/images/app-store.svg" title="app store" /></a>
                        </div>
                        <div class="mt-3">
                            <a href="{{user.app_path.andrio_path}}" (click)="andriodAppevent()"><img
                                    src="../../assets/images/google-play.svg" title="google-play" /></a>
                        </div>
                    </li>
                    <li>
                        <div class="scanner">
                            <span>Scan to Download</span>
                            <div class="scanner-div">
                                <div class="inner-scanner">
                                    <img src="../../../../assets/images/android-app.png" alt="">
                                    <p>Play Store</p>
                                </div>
                                <div class="separate"></div>
                                <div class="inner-scanner">
                                    <img src="../../../../assets/images/iOS-app.png" alt="">
                                    <p>Apple Play</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-12 d-lg-none">
                <img class="right-image" src="../../assets/images/app-new-image.svg" title="device" />
            </div>
        </div>
    </div>
</section>